import { BadgeCheck } from "lucide-react";
import { cn } from "@/lib/utils";

// Small "Official" pill for the @bloqtalk service account.
export function OfficialBadge({ className, size = 13, label = true }) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 rounded-full border border-bloq-blue/40 bg-bloq-blue/15 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-bloq-blue",
        className
      )}
      data-testid="official-badge"
      title="Official BLOQ Talk account"
    >
      <BadgeCheck style={{ width: size, height: size }} className="shrink-0" />
      {label && "Official"}
    </span>
  );
}
